<template>
  <v-col cols="12" xl="6">
    <v-lazy
        v-model="lazyActive"
        min-height="300"
        :options="{
        threshold: 0.1,
      }"
        transition="fade-transition"
    >
      <v-card elevation="5">
        <v-tabs v-model="tab" grow>
          <v-tabs-slider></v-tabs-slider>

          <v-tab
              v-for="item in tabItem"
              :key="item.id"
              @click="scrollTo(`#interestTab`)"
          >
            {{ item.name }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" size="20"
                >mdi-help-circle-outline
                </v-icon
                >
              </template>
              <span>{{ item.helpIconMsg }}</span>
            </v-tooltip>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="item in tabItem" :key="item.id">
            <v-card flat min-height="400">
              <Charts :option="interestReport"/>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-lazy>
  </v-col>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";


export default {
  props: {
    chartInfoState: Boolean,
  },
  components: {
    Charts: () => import("@/components/Charts.vue"),
  },
  methods: {
    ...mapMutations("taganalysis", ["setPopulationTagsReport"]),
    scrollTo(target) {
      this.$emit("goto", target);
    },
    getOption(tab) {
      let option = JSON.parse(JSON.stringify(this.reportData));
      let report = tab
          ? this.getInterestDistributed
          : this.getInterestStructure; //vuex
      option.xAxis.categories = report.map((el) => `${el.type}:${el.subject}`);

      option.series = [
        {
          name: "count",
          data: report.map((el) => el.count),
        },
      ];
      option.plotOptions.series.colors = report.map((el) => el.color)
      return option;
    }
  },
  computed: {
    ...mapGetters("taganalysis", [
      "getInterestStructure",
      "getInterestDistributed",
    ]),
    interestReport() {
      let option = this.reportData;
      let report = this.tab
          ? this.getInterestDistributed
          : this.getInterestStructure; //vuex
      option.xAxis.categories = report.map((el) => `${el.type}:${el.subject}`);

      option.series = [
        {
          name: "count",
          data: report.map((el) => el.count),
        },
      ];
      option.plotOptions.series.colors = report.map((el) => el.color)
      option.plotOptions.series.events = {
        click: (event) => {
          this.scrollTo(`#populationTag`);
          this.setPopulationTagsReport(event.point.category);
        },
      };
      return option;
    },
  },
  data: () => ({
    lazyActive: false,
    tab: null,
    tabItem: [
      {
        id: 1,
        name: "興趣類別排名",
        helpIconMsg: "以標籤類別進行排名，每個類別只顯示貼標數最高的標籤",
      },
      {
        id: 2,
        name: "興趣標籤排名",
        helpIconMsg: "以標籤貼標數進行排名，顯示前15個標籤",
      },
    ],
    reportData: {
      chart: {
        type: "bar",
      },
      title: {
        text: "",
      },
      xAxis: {
        categories: [],
        title: {
          text: null,
        },
      },
      yAxis: {
        min: 0,
        title: {
          // text: "Count",
          // align: "high",
          enabled: false,
        },
        labels: {
          overflow: "justify",
        },
      },
      tooltip: {
        valueSuffix: " 人",
      },
      plotOptions: {
        series: {
          cursor: "pointer",
          animation: {
            duration: 700,
            easing: "easeOutBounce",
          },
          colorByPoint: true,
        },
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      series: [],
      exporting: {
        relativeTo: "chart",
        buttons: {
          contextButton: {
            //改button樣式
            symbol: "download",
            menuItems: ["downloadCSV"],
          },
        },
      },
      helpIcon: {
        annotation: "",
        enabled: false,
      },
    },
  }),
  watch: {
    chartInfoState() {
      if (this.chartInfoState === true) {
        const interestStructure = {
          data: this.getOption(false),
          id: "interestTypeSort"
        };
        this.$emit("addChartInfo", interestStructure);
        const interestDistributed = {
          data: this.getOption(true),
          id: "interestTabSort"
        };
        this.$emit("addChartInfo", interestDistributed);
      }
    },
  },
};
</script>
